import { Autocomplete } from '@react-google-maps/api';
import React, { useEffect, useRef } from 'react';
import { AiOutlineSearch } from 'react-icons/ai';
import { MdCancel } from 'react-icons/md';

const StopInput = ({
  index,
  between,
  handleBetween,
  setFormValues,
  formValues,
}) => {
  const stopRef = useRef();

  useEffect(() => {
    if (formValues?.inBetween?.length > 0) {
      formValues?.inBetween?.map((stop) => {
        if (stop?.id === between?.id) stopRef.current.value = stop?.value;
      });
    }
  }, []);

  return (
    <div className='relative w-full block'>
      <Autocomplete
        onPlaceChanged={() =>
          handleBetween(between?.id, stopRef?.current?.value)
        }
      >
        <div className='ez__FormInput w-full flex items-center justify-between border border-ezGreen rounded-md p-4 mb-4'>
          <input
            type='text'
            id='stop'
            placeholder='Choose Stop'
            className='text-base text-ezGray'
            ref={stopRef}
          />
          <label
            htmlFor='startingPoint'
            className='text-ezGreen text-2xl cursor-pointer'
          >
            <AiOutlineSearch />
          </label>
          <button
            onClick={() =>
              setFormValues({
                ...formValues,
                inBetween: formValues?.inBetween?.filter(
                  (item) => item?.id !== between?.id
                ),
              })
            }
            className='absolute -top-2 -right-2 bg-white rounded-full'
          >
            <MdCancel className='w-5 h-5 text-ezRed' />
          </button>
        </div>
      </Autocomplete>
    </div>
  );
};

export default StopInput;
